export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 11_24.04ef4dcf.jpg";